require('./TextFieldSuggested.scss');

const React = require('react'),
    {PropTypes} = require('react'),
    {filter, some, find} = require('lodash/collection'),
    get = require('lodash/object').get,
    ContentUtils = require('utils/ContentUtils'),
    TextFieldSuggestedList = require('./TextFieldSuggestedList/TextFieldSuggestedList'),
    TextField = require('../TextField');

const DEFAULT_ATTRIBUTE_READER = 'name';
const DEFAULT_ATTRIBUTE_ID = 'id';

const TextFieldSuggested = React.createClass({displayName: "TextFieldSuggested",

    propTypes: {
        value: PropTypes.string,
        floatingLabelText: PropTypes.string,
        items: PropTypes.array,
        itemsDisabled: PropTypes.array,
        isDisabled: PropTypes.bool,
        errorText: PropTypes.string,
        readerAttribute: PropTypes.string,
        readerAttributeValue: PropTypes.string,
        onItemSelected: PropTypes.func,
        onEnterKeyDown: PropTypes.func,
        onPressScape: PropTypes.func,
        classCSS: PropTypes.string,
        hiddenIcon: PropTypes.bool
    },

    getInitialState() {
        return {
            itemSelected: null,
            textWritten: null,
            isPristine: true
        };
    },

    onChangeText(evt) {
        if (evt && evt.target) {
            const textWritten = evt.target.value;
            evt.preventDefault();

            this.setState({
                isPressedKeyArrowDown: false,
                isPristine: false,
                textWritten
            });
        }
    },

    onBlur() {
        const {
            onBlur,
            items,
            readerAttribute,
            value,
            readerAttributeValue
        } = this.props;
        const {itemSelected} = this.state;
        const textWritten = this.getTextWritten();

        const isListExpanded = this.isListExpanded();
        // check by text written and then by current item selected (if really have)
        let filterTextFiltered =
            textWritten || get(itemSelected, readerAttribute);

        const itemsFiltered = filterItems(
            items,
            filterTextFiltered,
            readerAttribute,
            value,
            readerAttributeValue
        );
        const matchSomeItemsWithTextWritten = some(
            itemsFiltered,
            item => get(item, readerAttribute) === filterTextFiltered
        );

        if (matchSomeItemsWithTextWritten) {
            let lastItemSelected;
            if (isListExpanded) {
                const firstItemEnable = find(
                    itemsFiltered,
                    item => get(item, readerAttribute) === filterTextFiltered && get(item, 'isDisabled') !== true
                );
                lastItemSelected = firstItemEnable;
            } else {
                lastItemSelected = itemSelected;
            }

            if (onBlur) {
                onBlur(lastItemSelected, ContentUtils.trim(textWritten));
            }
        } else {
            if (onBlur) {
                onBlur(null, ContentUtils.trim(textWritten));
            }
        }
    },

    isEditMode() {
        return !!this.props.value;
    },

    onClick(itemSelected) {
        const {onItemSelected} = this.props;
        if (itemSelected) {
            this.setState(
                {
                    itemSelected,
                    textWritten: null,
                    isPressedKeyArrowDown: false
                },
                () => {
                    this.focusInput();
                    if (itemSelected && onItemSelected) {
                        onItemSelected(itemSelected);
                    }
                }
            );
        }
    },

    getValue() {
        return this.state.itemSelected;
    },

    cleanValue() {
        this.setState({
            itemSelected: null
        });
    },

    isListExpanded() {
        const {textWritten} = this.state;
        const isCurrentFocusSomeListItem =
            document.activeElement &&
            document.activeElement.classList.contains(
                'bp-textfield-suggested-list-item'
            );
        return !!isCurrentFocusSomeListItem || !!textWritten;
    },

    onKeyDown(evt) {
        const {
            readerAttribute,
            items,
            onEnterKeyDown,
            onItemSelected,
            value
        } = this.props;

        if (!evt) {
            return;
        }

        const {itemSelected} = this.state;

        const isListExpanded = this.isListExpanded();
        const isListCollapsed = !isListExpanded;
        const isEditMode = this.isEditMode();
        const isNewMode = !isEditMode;
        const textWritten = this.getTextWritten();
        const isSomeTextWritten = !!textWritten;
        const isNotTextWritten = !isSomeTextWritten;

        const isPressedKeyArrowUp = evt.keyCode === 38;
        const isPressedKeyArrowDown = evt.keyCode === 40;
        const isPressedKeyEnter = evt.keyCode === 13;
        const isPressedKeyScape = evt.keyCode === 27;
        const isPressedKeyBackspace = evt.keyCode === 8;
        const isPressedKeyBackspaceAndWasRemovedAllText = isPressedKeyBackspace && get(textWritten, 'length', 0) <= 1;
        const isEmptyTextWrittenIsListCollapsedIsNewModeIsPressedEnter = isNotTextWritten && isListCollapsed && isNewMode && isPressedKeyEnter;
        const isItemEnable = evt.target && !evt.target.classList.contains('is-disabled');

        if (isPressedKeyScape) {
            this.onPressScape(isPressedKeyArrowDown);

        } else if (isPressedKeyBackspaceAndWasRemovedAllText) {
            this.onPressBackSpace(isPressedKeyArrowDown, onItemSelected);

        } else if (!isEmptyTextWrittenIsListCollapsedIsNewModeIsPressedEnter && isPressedKeyEnter && isItemEnable) {
            this.onPressEnter(
                items,
                textWritten,
                readerAttribute,
                isPressedKeyArrowDown,
                onEnterKeyDown,
                isListCollapsed,
                onItemSelected
            );
        } else if (isPressedKeyArrowDown && isListCollapsed) {
            this.onPressArrowDownAndListIsCollapsed(
                isEditMode,
                value,
                isPressedKeyArrowDown,
                readerAttribute,
                textWritten,
                itemSelected
            );

        } else if (isListExpanded && (isPressedKeyArrowDown || isPressedKeyArrowUp)) {
            this.onPressArrowUpOrDownArrow(
                isPressedKeyArrowUp,
                isPressedKeyArrowDown
            );
        }
    },

    onPressBackSpace(isPressedKeyArrowDown, onItemSelected) {
        this.setState(
            {
                isPressedKeyArrowDown,
                itemSelected: null,
                textWritten: null
            },
            () => {
                if (onItemSelected) {
                    onItemSelected(null);
                }
            }
        );
    },

    onPressScape(isPressedKeyArrowDown) {
        // just press scape and return the focus to the input
        this.setState(
            {
                isPressedKeyArrowDown,
                textWritten: null
            },
            () => {
                this.focusInput();
                if(this.props.onPressScape) {
                    this.props.onPressScape();
                }
            }
        );
    },

    onPressArrowUpOrDownArrow(isPressedKeyArrowUp, isPressedKeyArrowDown) {
        // the user if list is open, their want to walk
        // in the list of items with arrows (up & down), like a tab behavior
        let activeElement = document.activeElement;
        const isFocusOutSideOfList = !activeElement.classList.contains('bp-textfield-suggested-list-item');

        if (isFocusOutSideOfList) {
            const firstItem = this.getDOMNode().querySelector('.bp-textfield-suggested-list-item');
            if (firstItem) {
                firstItem.focus();
            }

        } else if (isPressedKeyArrowUp) {
            const nextElement = activeElement.previousElementSibling;

            if (nextElement) {
                activeElement.previousElementSibling.focus();
            } else {
                this.setState({textWritten: null, isPressedKeyArrowDown},
                    () => {
                        this.focusInput();
                    }
                );
            }

        } else if (isPressedKeyArrowDown) {
            const nextElement = activeElement.nextElementSibling;

            if (nextElement) {
                if (activeElement.nextElementSibling) {
                    activeElement.nextElementSibling.focus();
                }
            }
        }
    },

    onPressEnter(items,
                 textWritten,
                 readerAttribute,
                 isPressedKeyArrowDown,
                 onEnterKeyDown,
                 isListCollapsed,
                 onItemSelected) {

        const itemsFiltered = filterItems(items, textWritten, readerAttribute);
        const existSomeItemFiltered = get(itemsFiltered, 'length', 0) >= 1;
        const firstItemEnable = find(itemsFiltered, item => item.isDisabled !== true);

        if (existSomeItemFiltered) {

            this.setState(
                {
                    isPressedKeyArrowDown,
                    itemSelected: firstItemEnable,
                    textWritten: null
                },
                () => {
                    this.focusInput();
                    if (onItemSelected) {
                        onItemSelected(firstItemEnable);
                    }
                }
            );
        }

        // select the first of the list
        if (onEnterKeyDown && isListCollapsed) {
            onEnterKeyDown(firstItemEnable);
        }
    },

    onPressArrowDownAndListIsCollapsed(isEditMode,
                                       value,
                                       isPressedKeyArrowDown,
                                       readerAttribute,
                                       textWritten,
                                       itemSelected) {
        // check if write some text, otherwise just use the selected value, and
        // finally check default value (in case of edit mode)
        this.setState(
            {
                isPressedKeyArrowDown,
                textWritten: ContentUtils.trim(
                    textWritten
                        ? textWritten
                        : get(itemSelected, readerAttribute)
                )
            },
            () => {
                this.focusFirstItem();
            }
        );
    },

    focusFirstItem() {
        // user want to open dialog list to show all items possibles
        const firstItemEl = this.getDOMNode().querySelector(
            '.bp-textfield-suggested-list-item'
        );
        if (firstItemEl) {
            firstItemEl.focus();
        }
    },

    focusInput() {
        // maybe reach to limit of item list, return focus to text-field
        this.getDOMNode().querySelector('input').focus();
    },

    getTextWritten() {
        return this.getDOMNode().querySelector('.bp-textfield-suggested input').value;
    },

    render() {
        const {
            readerAttribute,
            items,
            itemsDisabled,
            floatingLabelText,
            value,
            errorText,
            readerAttributeValue,
            isDisabled,
            classCSS,
            hiddenIcon
        } = this.props;
        const {
            itemSelected,
            isPristine,
            isPressedKeyArrowDown,
            textWritten
        } = this.state;

        const itemsFiltered = filterItems(
            items,
            textWritten,
            readerAttribute,
            value,
            readerAttributeValue
        );
        const itemsDisabledFiltered = filterItems(
            itemsDisabled,
            textWritten,
            readerAttribute,
            value,
            readerAttributeValue
        );
        const consumerWriteText = !!textWritten;
        const consumerRemoveAllText = !isPristine && textWritten === '';

        // relay first in internal (`itemSelected`) state
        // because is the last user change. If not exist
        // then check default value (`consumerDefinedValue`)
        const currentItem = itemSelected
            ? itemSelected
            : isPristine ? value : null;
        const currentValue = get(currentItem, readerAttribute);

        // relay always in the last users changes
        const textValue = consumerRemoveAllText
            ? null
            : consumerWriteText ? textWritten : currentValue;

        // just if consumer not write text, not need to expand the suggested list
        // only exception when hit arrow down
        const isExpanded = isPressedKeyArrowDown || !!consumerWriteText;



        return (
            React.createElement("div", {
                className: "bp-textfield-suggested"+ (classCSS ? ' ' + classCSS : ''), 
                onKeyDownCapture: this.onKeyDown
            }, 
                React.createElement(TextField, {
                    errorText: errorText, 
                    floatingLabelText: floatingLabelText, 
                    icon: hiddenIcon ? '' : 'search', 

                    onChange: this.onChangeText, 
                    onBlur: this.onBlur, 
                    onEnterKeyDown: this.onBlur, 
                    disabled: isDisabled, 
                    value: textValue}
                ), 
                React.createElement(TextFieldSuggestedList, {
                    textWritten: textValue, 
                    isExpanded: isExpanded, 
                    items: itemsFiltered, 
                    itemsDisabled: itemsDisabledFiltered, 
                    readerAttribute: readerAttribute, 
                    onClick: this.onClick}
                )
            )
        );
    }
});

function filterItems(items,
                     textWritten,
                     readerAttribute = DEFAULT_ATTRIBUTE_READER,
                     currentSelected,
                     readerAttributeValue = DEFAULT_ATTRIBUTE_ID) {
    const notFilterDefined = ContentUtils.isNullOrEmpty(textWritten);
    const textWrittenCleaned = ContentUtils.trim(textWritten);

    if (notFilterDefined) {
        return items;
    }

    let currentSelectedId = null;
    if (currentSelected) {
        currentSelectedId = get(currentSelected, readerAttributeValue);
    }

    return filter(items, item => {
        if (currentSelectedId) {
            const itemSelectedId = get(item, readerAttributeValue);
            const isCurrentItemSelected = itemSelectedId === currentSelectedId;
            if (isCurrentItemSelected) {
                // enter here means don't want to repeat the item selected in the list
                // to avoid duplication issues validations
                return false;
            }
        }

        return (get(item, readerAttribute, '') || '')
            .toLowerCase()
            .includes(textWrittenCleaned.toLowerCase());
    });
}

module.exports = TextFieldSuggested;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/TextField/TextFieldSuggested/TextFieldSuggested.jsx
 **/